import { faTrashAlt, faMultiply, faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";

import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { Button } from "userful-chronos-common-ui/dist";
import { deleteCluster } from "../../../store/constellations/constellationsManager";
import { IClusterInfo, IConstellationInfo } from "../../../model/CarbonExternalModels";
import { UserfulConfirmationDialog } from "userful-chronos-common-ui/dist/widgets";

interface IProps {
    foundObject: { cluster: IClusterInfo; constellation: IConstellationInfo };
}

export default function ClusterDelete(props: IProps) {
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    if (!permissions.isClusterSuppressor) {
        return null;
    }

    const isConnected =
        props.foundObject.cluster.clusterDeviceInfo.length > 0 && props.foundObject.cluster.status === "CONNECTED";

    window.console.log(props.foundObject);

    return (
        <>
            <Dropdown.Item
                onClick={() => {
                    setShowConfirmation(true);
                }}
            >
                <div className="gcm-icon-dropdown-menu-icon-container">
                    <FontAwesomeIcon icon={faTrashAlt} />
                </div>
                <p>Delete</p>
            </Dropdown.Item>

            <UserfulConfirmationDialog
                show={showConfirmation}
                onCancel={() => {
                    setShowConfirmation(false);
                }}
                icon={{ icon: faWarning, color: "#D13E2C" }}
                title="Delete Cluster"
                replaceBody={
                    <>
                        <p>
                            {isConnected
                                ? `You are not able to delete ${props.foundObject.cluster.name}. Cluster cannot be deleted from GCM while Online and must be unpaired from the local system.`
                                : `Are you sure you want to delete ${props.foundObject.cluster.name}?  Cluster will need to be unpaired and paired again to reconnect with GCM.`}
                        </p>
                        <p>
                            {isConnected
                                ? `Please access the local system configuration menu to unpair.`
                                : `This method of deletion is not recommended. If possible, unpair using the local system configuration menu instead.`}
                        </p>
                    </>
                }
                replaceFooter={
                    <>
                        <Button
                            variant="secondary"
                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="danger"
                            disabled={isConnected}
                            onClick={(e) => {
                                setShowConfirmation(false);
                                deleteCluster(props.foundObject.cluster.id, "INTERNAL");
                            }}
                        >
                            Delete
                        </Button>
                    </>
                }
            />
            {/* 
            <Modal
                centered
                show={showConfirmation}
                onHide={() => {
                    setShowConfirmation(false);
                }}
            >
                <div className="gcm-pop-up-modal-wrapper">
                    <div className="gcm-pop-up-modal-wrapper-body">
                        <div className="gcm-pop-up-modal-wrapper-head">
                            <div className="gcm-pop-up-modal-wrapper-title">
                                <FontAwesomeIcon icon={faTrashAlt} />
                                <h1>Delete Cluster</h1>
                            </div>
                            <Button
                                variant="secondary"
                                iconOnly
                                onClick={() => {
                                    setShowConfirmation(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faMultiply} />
                            </Button>
                        </div>
                        <p>
                            Are you sure you want to delete the cluster: <strong>"{props.foundObject.cluster.name}"</strong>?
                        </p>
                    </div>
                    <div className="confirmationDialogHorizontalWrapper reversed">
                        <Button
                            variant="danger"
                            onClick={(e) => {
                                setShowConfirmation(false);
                                deleteCluster(props.foundObject.cluster, "INTERNAL");
                            }}
                        >
                            Delete
                        </Button>
                        <Button
                            variant="secondary"

                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal> */}
        </>
    );
}
